import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';
import ReferenceDataActions from '../actions/ReferenceDataActions';
import { actions as UserActionConstants } from '../constants/UserConstants';

var _state = {
    referralSources: []
};

class ReferenceDataStoreClass extends EventEmitter {
    getState() {
        return _state;
    }

    emitChange(callback) {
        this.emit('ReferenceDataChange', callback)
    }

    addChangeListener( callback ) {
        this.on('ReferenceDataChange', callback)
    }

    removeChangeListener( callback ) {
        this.removeListener('ReferenceDataChange', callback)
    }
}

const ReferenceDataStore = new ReferenceDataStoreClass();

ReferenceDataStore.dispatchToken = AppDispatcher.register(action => {
    switch(action.actionType) {
        case UserActionConstants.SELECT_LOCATION:
            _state.referralSources = [];
            ReferenceDataActions.loadAll();
            break;
        case ReferenceDataActions.actions.LOADED_ALL_REFERENCE_DATA:
            _state.referralSources = action.data.ReferralSources;
            break;
    }
});

export default ReferenceDataStore



// WEBPACK FOOTER //
// ./ui_src/app/stores/ReferenceDataStore.jsx